<template>
<div :class='topClass'>
  <div v-if='showing'
       class="m-0 h-screen-fixed fixed pin pbc-modal-background flex justify-center left-0 top-0 right-0 bottom-0 inset-y-auto pbc-z-level-5 flex flex-col" 
       @click.self='$emit("close")'>
    <div class="max-w-md self-center">
      <div class="pbc-message-top m-2 rounded grow flex flex-col overflow-auto" style='box-sizing: border-box'>
        <div class="text-center flex">
          <div class="bg-white rounded border float-left transition duration-500 ease-in-out scale-100">
            <slot>
              <close v-if='type === "error"' :size='64' class="text-center" />
              <check v-else :size='64' class="text-center" />
            </slot>
          </div>
          <div class="pbc-message-title m-4 text-xl flex-1 overflow-auto leading-normal text-xl font-semibold float-left">
            {{title}}
          </div>
        </div>
        <slot name='controls' :close='close' :done='done'>
          <div class="pbc-message-controls py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid">
            <pbc-button class="bg-white" @click="done" ><span class="mx-4">OK</span></pbc-button>
          </div>
        </slot>
      </div>
    </div>
	</div>
</div>
</template>
<script>
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
export default {
  props:{
  },
  components:{
    Check,
    Close
  },
  data() {
    return {
      showing: false,
      title:'',
      type:'info'
    }
  },
  methods:{
    show({title, onClose, type}) {
      this.title = title;
      this.onClose = onClose;
      this.showing = true;
      this.type = type || 'info';
    },
    close() {
      console.log('pressy close');
      this.showing = false;
      this.onClose && this.onClose();
      this.$emit('close');
    },
    done() {
      console.log('pressy done');
      this.showing = false;
      this.onClose && this.onClose();
      this.$emit('done');
    }
  },
  computed: {
    topClass() {
      if (this.type === 'error') {
        return 'pbc-message-error'
      } else {
        return 'pbc-message-info'
      }
    }
  }
}
</script>
<style>

.pbc-message-error .pbc-message-controls {
  @apply border-red-500;
}
.pbc-message-error .pbc-message-top {
  @apply bg-red-200 ;
  @apply text-red-600;
}
.pbc-message-error .pbc-message-title {
  @apply text-red-700;
}


.pbc-message-info .pbc-message-controls {
  @apply border-green-500;
}
.pbc-message-info .pbc-message-title {
  @apply text-green-700;
}
.pbc-message-info .pbc-message-top {
  @apply bg-green-200 ;
  @apply text-green-600;
}
</style>
